import type { Plugin } from 'vue';
import { Client } from '@keyvue/one-api-client';
import { Company, CompanyAPI as LegacyCompanyAPI, configureAPIs as configureLegacyAPIs, User, UserAPI as LegacyUserAPI } from '@keyvue/one-api-client-legacy';
import { ref } from 'vue';

export default {
    install: (app) => {
        /** instantiates the client with barebones config to be able to make requests */
        const currentClient = new Client(
            {
                baseURL: import.meta.env.VITE_API_HOST,
                basePath: import.meta.env.VITE_API_BASEPATH,
            },
        );

        const legacyUser = ref<User | null>(null);
        const legacyCompany = ref<Company | null>(null);

        /** hooks into token change to configure legacy clients */
        currentClient.session.setTokenListener(async () => {
            configureLegacyAPIs({
                baseURL: import.meta.env.VITE_LEGACY_HOST,
                basePath: import.meta.env.VITE_LEGACY_BASEPATH,
                accessToken: currentClient.session.accessToken ?? undefined,
                refreshToken: currentClient.session.refreshToken ?? undefined,
            });
        });

        /** hooks into session load to retrieve legacy resources */
        currentClient.session.setSessionLoadPromiseListener(() => {
            if (!currentClient.session.isLoggedIn) {
                return [];
            }

            const promises: Promise<any>[] = [];

            if (!legacyUser.value && currentClient.session.userId) {
                promises.push(LegacyUserAPI.getForOneApp(currentClient.session.userId.toString()).then((response) => {
                    legacyUser.value = response;
                }));
            }

            if (!legacyCompany.value && currentClient.session.companyId) {
                promises.push(LegacyCompanyAPI.getForOneApp(currentClient.session.companyId.toString()).then((response) => {
                    legacyCompany.value = response;
                }));
            }

            return promises;
        });

        // TODO: hook into eventBus to refresh user on user change

        app.provide('legacyUser', legacyUser);
        app.provide('legacyCompany', legacyCompany);
        app.provide('client', currentClient);
    },
} as unknown as Plugin;
